import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App.tsx";
import "./index.css";
import { isBrowserSupported, renderUnsupportedBrowser } from "./lib/browserSupport.ts";
import { GlobalErrorFallback } from "./components/GlobalErrorBoundary";
import { reportToRollbar } from "./lib/rollbarReport";
import { registerWebVitals } from "./lib/webVitals";

if (!isBrowserSupported()) {
  renderUnsupportedBrowser();
} else {
  registerWebVitals();
  createRoot(document.getElementById("root")!).render(
    <ErrorBoundary
      FallbackComponent={GlobalErrorFallback}
      onReset={() => {
        // Force Hard Reload to clear stale state completely
        window.location.href = "/";
      }}
      onError={(error, info) => {
        reportToRollbar(error, {
          tags: { boundary: "root" },
          extra: { componentStack: info.componentStack },
        });
      }}
    >
      <App />
    </ErrorBoundary>,
  );
}
